import React from 'react';
import PropTypes from 'prop-types';

import { Flex, Image, Text } from 'Components/Base';
import { Modal, ModalFooter } from 'Components/Modal';
import getConfig from 'Util/Config';

const {
  classroom: { quiz = {} },
} = getConfig();
const { imagePrefix = '', imageSuffix = 'svg' } = quiz;

export const GRADED_EXAM_MODAL_VARIANT = {
  EXAM_SUBMIT: 'EXAM_SUBMIT',
  EXAM_ESCAPE: 'EXAM_ESCAPE',
  EXAM_TIMEOUT: 'EXAM_TIMEOUT',
};

export const GRADED_EXAM_MODAL_VARIANT_PROPS = {
  [GRADED_EXAM_MODAL_VARIANT.EXAM_SUBMIT]: {
    header: 'ส่งแบบทดสอบ',
    description1: 'กรุณาทวนคำตอบของคุณก่อนส่งแบบทดสอบ',
    description2: 'คำตอบของคุณจะถูกตรวจและไม่สามารถแก้ไขได้อีกหลังจากนั้น',
    imageUrl: `/assets/images/quiz/${imagePrefix}quiz-landing.${imageSuffix}`,
  },
  [GRADED_EXAM_MODAL_VARIANT.EXAM_ESCAPE]: {
    header: 'ออกจากแบบทดสอบ',
    description1: 'คุณต้องการออกจากควิซใช่หรือไม่',
    description2: 'ระบบจะไม่ตัดจำนวนรอบแบบทดสอบของคุณ',
    imageUrl: `/assets/images/quiz/${imagePrefix}quiz-landing.${imageSuffix}`,
  },
  [GRADED_EXAM_MODAL_VARIANT.EXAM_TIMEOUT]: {
    header: 'หมดเวลาสอบ',
    description1: 'เวลาในการสอบของคุณหมดแล้ว',
    description2: 'กรุณาทำแบบทดสอบอีกครั้งเพื่อวัดผล',
    imageUrl: `/assets/images/quiz/${imagePrefix}quiz-timeout.${imageSuffix}`,
  },
};

const GradedExamModal = ({
  isOpen,
  header,
  description1,
  description2,
  imageUrl,
  primaryButtonLabel,
  onPrimaryButtonClick,
  secondaryButtonLabel,
  onSecondaryButtonClick,
  ...props
}) => {
  return (
    <Modal
      muiProps={{ isActive: isOpen }}
      header={
        <Flex pb={4} flexDirection={'column'} alignItems={'center'}>
          <Image src={imageUrl} pb={4} />
          <Text
            textStyle={{ _: 'heading4', sm: 'heading2' }}
            textAlign={'center'}
            fontWeight={'medium'}
          >
            {header}
          </Text>
        </Flex>
      }
      contents={
        <Flex pb={7} flexDirection={'column'} alignItems={'center'}>
          <Text
            color={'greyscale.grey3'}
            textStyle={{ _: 'Body2', sm: 'Body1' }}
            fontWeight={'normal'}
            textAlign={'center'}
            pb={2}
          >
            {description1}
          </Text>
          <Text
            color={'greyscale.grey3'}
            textStyle={{ _: 'Body2', sm: 'Body1' }}
            fontWeight={'normal'}
            textAlign={'center'}
          >
            {description2}
          </Text>
        </Flex>
      }
      footer={
        <ModalFooter
          primaryButtonLabel={primaryButtonLabel}
          onPrimaryButtonClick={onPrimaryButtonClick}
          secondaryButtonLabel={secondaryButtonLabel}
          onSecondaryButtonClick={onSecondaryButtonClick}
          flexDirection={{ _: 'column-reverse', sm: 'row' }}
          justifyContent={'center'}
          width={1}
        />
      }
      {...props}
    />
  );
};

GradedExamModal.propTypes = {
  isOpen: PropTypes.bool,
  header: PropTypes.string,
  description1: PropTypes.string,
  description2: PropTypes.string,
  imageUrl: PropTypes.string,
  primaryButtonLabel: PropTypes.string,
  onPrimaryButtonClick: PropTypes.func,
  secondaryButtonLabel: PropTypes.string,
  onSecondaryButtonClick: PropTypes.func,
};

export default GradedExamModal;
